export * from './ApiIdMapper';

const envOverride = (key: string, path: string): string => {
    const overridePath: string | undefined = process.env['NX_PUBLIC_DD_API_PATH.' + key];
    return overridePath ?? path;
};

export const APIPath = {
    CONFIG_PAYMENT_CONFIG: envOverride('CONFIG_PAYMENT_CONFIG', '/api/v2/subscriptions/payment-config'),
    USER_LOCATE_USER: envOverride('USER_LOCATE_USER', '/api/v2/auth/locate-user'),
    USER_EMAIL_VERIFICATION_GENERATE_PIN: envOverride(
        'USER_EMAIL_VERIFICATION_GENERATE_PIN',
        '/v1/:appKey/email/:email'
    ),
    USER_EMAIL_VERIFICATION_VERIFY_PIN: envOverride(
        'USER_EMAIL_VERIFICATION_VERIFY_PIN',
        '/v1/email/:appKey/verifications/:verificationGuid'
    ),
    USER_LOGIN_OTP: envOverride('USER_LOGIN_OTP', '/v2/:appKey/user/login/otp'),
    USER_LOGIN_STEP_1: envOverride('USER_LOGIN_STEP_1', '/v3/:appKey/login/user'),
    USER_LOGIN_CREDENTIALS: envOverride('USER_LOGIN_CREDENTIALS', '/v3/:appKey/login/credentials'),
    USER_LOGIN_WITH_TOKEN: envOverride('USER_LOGIN_WITH_TOKEN', '/v2/:appKey/login/credentials/token'),
    USER_CHANGE_PASSWORD: envOverride('USER_CHANGE_PASSWORD', '/v1/:appKey/users/:username/password'),
    USER_GENERATE_PIN: envOverride('USER_GENERATE_PIN', '/v3/:appKey/msisdn/verification'),
    USER_VERIFY_PIN: envOverride('USER_VERIFY_PIN', '/v3/:appKey/msisdn/verification/:msisdn'),
    USER_RESET_PASSWORD_STEP1: envOverride('USER_RESET_PASSWORD_STEP1', '/v3/:appKey/user/password/reset/otp'),
    USER_RESET_PASSWORD_STEP2: envOverride('USER_RESET_PASSWORD_STEP2', '/v3/:appKey/user/password/reset/verification'),
    USER_GENERATE_PIN_AUTHENTICATED_USER: envOverride(
        'USER_GENERATE_PIN_AUTHENTICATED_USER',
        '/v2/:appKey/users/:username/subscriptions/two-step'
    ),
    USER_VERIFY_PIN_AUTHENITCATED_USER: envOverride(
        'USER_VERIFY_PIN_AUTHENITCATED_USER',
        '/v2/:appKey/users/:username/subscriptions/two-step/verifications/:msisdn'
    ),
    USER_FORGOT_PASSWORD_GENERATE_PIN_BY_EMAIL: envOverride(
        'USER_FORGOT_PASSWORD_GENERATE_PIN_BY_EMAIL',
        '/v1/:appKey/otp/email/:email'
    ),
    USER_FORGOT_PASSWORD_VERIFIY_BY_EMAIL: envOverride(
        'USER_FORGOT_PASSWORD_VERIFIY_BY_EMAIL',
        '/v1/:appKey/otp/email/verifications/:verificationGuid'
    ),
    USER_FORGOT_PASSWORD_UPDATE_BY_EMAIL: envOverride(
        'USER_FORGOT_PASSWORD_UPDATE_BY_EMAIL',
        '/v1/:appKey/otp/email/passwords'
    ),
    USER_FORGOT_PASSWORD_GENERATE_PIN_BY_MSISDN: envOverride(
        'USER_FORGOT_PASSWORD_GENERATE_PIN_BY_MSISDN',
        '/v1/:appKey/otp/msisdn/:msisdn'
    ),
    USER_FORGOT_PASSWORD_VERIFIY_BY_MSISDN: envOverride(
        'USER_FORGOT_PASSWORD_VERIFIY_BY_MSISDN',
        '/v1/:appKey/otp/msisdn/verifications/:verificationGuid'
    ),
    USER_FORGOT_PASSWORD_UPDATE_BY_MSISDN: envOverride(
        'USER_FORGOT_PASSWORD_UPDATE_BY_MSISDN',
        '/v1/:appKey/otp/msisdn/passwords'
    ),
    USER_SUBSCRIPTION_STATUS: envOverride(
        'USER_SUBSCRIPTION_STATUS',
        '/v3/:apiKey/:username/subscriptions/status?productKey=:productKey'
    ),
    USER_SUBSCRIPTION_STATUS_NEW: envOverride(
        'USER_SUBSCRIPTION_STATUS_NEW',
        '/v1/:apikey/:userName/subscriptions/status?productKey=:productKey'
    ),
    USER_UNSUBSCRIBE: envOverride('USER_UNSUBSCRIBE', '/api/v2/subscriptions/unsubscribe'),
    USER_TPAY_REDIRECT_SUBSCRIBE_NEW_USER: envOverride(
        'USER_TPAY_REDIRECT_SUBSCRIBE_NEW_USER',
        '/v2/:appKey/:username/subscribe/redirect/:msisdn'
    ),
    USER_TPAY_REDIRECT_SUBSCRIBE_EXISTING_USER: envOverride(
        'USER_TPAY_REDIRECT_SUBSCRIBE_EXISTING_USER',
        '/v2/:appKey/users/:username/subscribe/redirect/:msisdn'
    ),
    // USER_PARTNER_ACTIVATE_LINK: envOverride(
    //     'USER_PARTNER_ACTIVATE_LINK',
    //     '/v1/:apiKey/:partnerName/activation/link/generate'
    // ),
    USER_PARTNER_ACTIVATE_LINK: envOverride(
        'USER_PARTNER_ACTIVATE_LINK',
        '/api/v2/integrations/netflix-get-activation-link'
    ),
    USER_VERIFY_USER: envOverride('USER_VERIFY_USER', '/api/v2/auth/verify-user'),
    CONTENT_CHANNELS_MINI_EPG: envOverride('CONTENT_CHANNELS_MINI_EPG', '/v1/:appKey/miniepg'),
    CONTENT_CHANNELS_ARRIS_STB: envOverride('CONTENT_CHANNELS_ARRIS_STB', '/v3/:appKey/channels'),
    CONTENT_CHANNELS: envOverride('CONTENT_CHANNELS', '/v2/:apiKey/channels'),
    CHANNELS: envOverride('CHANNELS', '/v2/:apiKey/channels'),
    CONTENT_INFO: envOverride('CONTENT_CHANNELS', '/:apiKey/channelInfo?byCustomValue=:byCustomValue'),
    CONTENT_CHANNELS_CDN_SCHEDULE: envOverride(
        'CONTENT_CHANNELS_CDN_SCHEDULE',
        '/channels/schedules/:date/:timeZoneOffset'
    ),
    DEVICE_ADD: envOverride('DEVICE_ADD', '/v1/:apiKey/users/:username/devices'),
    DEVICE_DELETE: envOverride('DEVICE_DELETE', '/v1/:apiKey/users/:username/devices/:guid'),
    QR_GENERATE_CODE: envOverride('QR_GENERATE_CODE', '/v1/:appKey/user/login/code'),
    QR_AUTHENTICATE_CODE: envOverride('QR_AUTHENTICATE_CODE', '/v1/:apiKey/login/:code/authenticate'),
    QR_CODE_LOGIN: envOverride('QR_CODE_LOGIN', '/v1/:appKey/user/login/qr'),
    QR_CODE_PAIRING: envOverride('QR_CODE_PAIRING', '/v1/login/codes/:bucketId'),
    QR_CODE_LINK: envOverride('QR_CODE_LINK', '/api/v2/subscription/signup-qr-poll'),
    ENTITLEMENT_QITAF_GENERATE_OTP: envOverride('ENTITLEMENT_QITAF_GENERATE_OTP', '/v1/:appKey/qitaf/otp/generate'),
    ENTITLEMENT_QITAF_TVOD_GENERATE_OTP: envOverride(
        'ENTITLEMENT_QITAF_GENERATE_OTP',
        '/entitlements/v1/:apiKey/qitaf/tvod/otp/generate'
    ),
    ENTITLEMENT_QITAF_VERIFY_OTP: envOverride('ENTITLEMENT_QITAF_VERIFY_OTP', '/v1/:appKey/qitaf/otp/verify'),
    ENTITLEMENT_QITAF_TVOD_VERIFY_OTP: envOverride(
        'ENTITLEMENT_QITAF_GENERATE_OTP',
        '/entitlements/v1/:apiKey/qitaf/tvod/otp/verify'
    ),
    ENTITLEMENT_ALLOWED_COUNTRIES: envOverride('ENTITLEMENT_ALLOWED_COUNTRIES', '/v1/:apiKey/allowed-countries'),
    ENTITLEMENT_AVAILABLE_PACKAGES: envOverride(
        'ENTITLEMENT_AVAILABLE_PACKAGES',
        '/v1/:apiKey/users/:username/subscriptions/available-packages'
    ),
    ENTITLEMENT_TVODS: envOverride('ENTITLEMENT_TVODS', '/v1/:apiKey/users/:username/products/tvods'),
    ENTITLEMENT_TVOD_PRICING_TEMPLATE: envOverride(
        'ENTITLEMENT_TVOD_PRICING_TEMPLATE',
        '/entitlements/v1/tvod/templates'
    ),
    ENTITLEMENT_ALL: envOverride('ENTITLEMENT_ALL', '/v1/:apiKey/users/:username/products'),
    ENTITLEMENT_ALL_SUBSCRIPTION_TIERS: envOverride(
        'ENTITLEMENT_ALL_SUBSCRIPTION_TIERS',
        '/user-entitlements/v1/:apikey/subscriptions-tiers'
    ),
    ENTITLEMENT_ALL_SUBSCRIPTION_TIERS_V2: envOverride(
        'ENTITLEMENT_ALL_SUBSCRIPTION_TIERS',
        '/user-entitlements/v2/:apikey/subscriptions-tiers'
    ),

    ENTITLEMENT_CHANNELS: envOverride('ENTITLEMENT_CHANNELS', '/v3/:apiKey/users/:username/channels'),
    ENTITLEMENT_PROFILE_EPG_CHANNELS: envOverride(
        'ENTITLEMENT_PROFILE_EPG_CHANNELS',
        '/entitlements/v2/:apiKey/users/:username/:profile/channels/miniepg'
    ),
    ENTITLEMENT_SUBSCRIBE: envOverride('ENTITLEMENT_SUBSCRIBE', '/v1/:appKey/users/:username/subscriptions'),
    ENTITLEMENT_TVOD_PURCHASE: envOverride(
        'ENTITLEMENT_TVOD_PURCHASE',
        '/entitlements/v1/:appKey/users/:username/purchases/onetime'
    ),
    ENTITLEMENT_TVOD_OTP_GENERATE: envOverride(
        'ENTITLEMENT_TVOD_OTP_GENERATE',
        '/user-entitlements/v1/:appKey/users/:username/purchases/onetime/otp'
    ),
    ENTITLEMENT_TVOD_OTP_VERIFY: envOverride(
        'ENTITLEMENT_TVOD_OTP_GENERATE',
        '/user-entitlements/v1/:appKey/users/:username/purchases/onetime/otp/verify'
    ),
    ENTITLEMENT_PAYMENT_SWITCH_GENERATE_PIN: envOverride(
        'ENTITLEMENT_PAYMENT_SWITCH_GENERATE_PIN',
        '/api/v2/users/payment-switch-generate'
    ),
    ENTITLEMENT_PAYMENT_SWITCH_VERIFY_PIN: envOverride(
        'ENTITLEMENT_PAYMENT_SWITCH_VERIFY_PIN',
        '/api/v2/users/payment-switch-verify'
    ),
    ENTITLEMENT_NETFLIX_FORGOT_ACCOUNT: envOverride(
        'ENTITLEMENT_NETFLIX_FORGOT_ACCOUNT',
        '/api/v2/integrations/netflix-forgot-account'
    ),
    ENTITLEMENT_AMAZON_ACTIVTION_LINK: envOverride(
        'ENTITLEMENT_AMAZON_ACTIVTION_LINK',
        '/api/v2/integrations/amazon-get-activation-link'
    ),
    ENTITLEMENT_AMAZON_ACCOUNT_RECOVERY: envOverride(
        'ENTITLEMENT_AMAZON_ACCOUNT_RECOVERY',
        '/api/v2/integrations/amazon-forgot-account'
    ),
    MPX_ALL_VOD_FEED: envOverride('MPX_ALL_VOD_FEED', 'all-vods'),
    PROFILE_CUD: envOverride('PROFILE_CUD', '/v2/:apiKey/users/profile'),
    PROFILE_LIST: envOverride('PROFILE_LIST', '/v4/:apiKey/users/:username/profiles'),
    PROFILE_SWITCH: envOverride('PROFILE_SWITCH', '/v2/:apiKey/users/:username/profile/switch'),
    PROFILE_UPDATE: envOverride('PROFILE_UPDATE', '/api/v2/profiles/update'),
    PROFILE_DELETE: envOverride('PROFILE_DELETE', '/api/v2/profiles/delete'),
    PROFILE_ADD: envOverride('PROFILE_ADD', '/api/v2/profiles/add'),
    PROFILE_FAVORITE: envOverride('PROFILE_FAVORITE', '/v2/:apiKey/profile/:profileName/favorites/channels'),
    PROFILE_WATCHLIST: envOverride('PROFILE_WATCHLIST', '/v2/:apiKey/profile/:profileName/watchlist/:type'),
    PROFILE_WATCHLIST_VOD: envOverride('PROFILE_WATCHLIST_VOD', '/v2/:apiKey/profile/:profileName/watchlist/vod'),
    PROFILE_WATCHLIST_LINEAR: envOverride(
        'PROFILE_WATCHLIST_LINEAR',
        '/v2/:apiKey/profile/:profileName/watchlist/linear'
    ),
    PROFILE_GET_WATCHLIST: envOverride('PROFILE_GET_WATCHLIST', '/v2/:apiKey/profile/:profileName/watchlist'),
    PROFILE_CREATE_PARENTAL_PIN: envOverride('PROFILE_CREATE_PARENTAL_PIN', '/v1/:apiKey/users/parentalLock'),
    PROFILE_VALIDATE_PARENTAL_PIN: envOverride(
        'PROFILE_VALIDATE_PARENTAL_PIN',
        '/v1/:apiKey/users/parentalLock/validate'
    ),
    PROFILE_GET_PARENTAL_PIN: envOverride('PROFILE_GET_PARENTAL_PIN', '/v1/:apiKey/users/:username/parentalLock'),
    PROFILE_UPDATE_PARENTAL_PIN: envOverride(
        'PROFILE_UPDATE_PARENTAL_PIN',
        '/v1/:apiKey/users/:username/parentalLock/reset'
    ),
    PROFILE_RESET_PARENTAL_PIN_OTP: envOverride('PROFILE_RESET_PARENTAL_PIN_OTP', '/v1/:apiKey/users/otp/generate'),
    PROFILE_RESET_PARENTAL_PIN_OTP_VERIFY: envOverride(
        'PROFILE_RESET_PARENTAL_PIN_OTP_VERIFY',
        '/v1/:apiKey/users/otp/verify'
    ),
    PROFILE_RESET_PARENTAL_PIN_WITH_OTP: envOverride(
        'PROFILE_RESET_PARENTAL_PIN_WITH_OTP',
        '/v1/:apiKey/users/parentalLock/reset'
    ),
    PROFILE_VALIDATE_PASSWORD: envOverride('PROFILE_VALIDATE_PASSWORD', '/v1/:apiKey/users/:username/reauth'),
    INTERNAL_VERIFY_USER: envOverride('INTERNAL_VERIFY_USER', '/api/v2/subscription/check-user'),
    ZENDESK_SUBMIT_FORM: envOverride('ZENDESK_SUBMIT_FORM', '/v2/requests'),
    CMS_CONFIGURATION: envOverride('CMS_CONFIGURATION', '/configuration'),
    BIGSCREEN_CMS_MOODS: envOverride('BIGSCREEN_CMS_MOODS', '/stc-tv/locale/configs/moods_recommendation.json'),
    CMS_LANGUAGE: envOverride('CMS_LANGUAGE', '/language/:language'),
    CMS_SCREEN: envOverride('CMS_SCREEN', '/screen/:screen'),
    SLP_API_FORM_SIGNATURE: envOverride('SLP_API_FORM_SIGNATURE', '/api/v2/token'),
    SLP_API_LOGIN_VERIFY: envOverride('SLP_API_LOGIN_VERIFY', '/api/v2/auth/locate-user-otp'),
    SLP_API_LOGIN_CREDENTIALS: envOverride('SLP_API_LOGIN_CREDENTIALS', '/api/v2/auth/login-credentials'),
    SLP_API_LOGIN_OTP: envOverride('SLP_API_LOGIN_OTP', '/api/v2/auth/login-otp'),
    ENTITLEMENT_ADDON_PURCHASE: envOverride('ENTITLEMENT_ADDON_PURCHASE', '/api/v2/subscriptions/addon-purchase'),
    SLP_API_FORGOT_PASSWORD_SEND_OTP: envOverride(
        'SLP_API_FORGOT_PASSWORD_SEND_OTP',
        '/api/v2/auth/forgot-password-send-otp'
    ),
    SLP_API_FORGOT_PASSWORD_RESEND_OTP: envOverride(
        'SLP_API_FORGOT_PASSWORD_RESEND_OTP',
        '/api/v2/auth/forgot-password-resend-otp'
    ),
    SLP_API_FORGOT_PASSWORD_VERIFY_OTP: envOverride(
        'SLP_API_FORGOT_PASSWORD_VERIFY_OTP',
        '/api/v2/auth/forgot-password-verify-otp'
    ),
    SLP_API_FORGOT_PASSWORD_RESET: envOverride('SLP_API_FORGOT_PASSWORD_RESET', '/api/v2/auth/forgot-password-reset'),
    POPCORN_API_FORGOT_PIN: envOverride('POPCORN_API_FORGOT_PIN', '/api/v2/auth/forgot-pin'),
    SLP_API_VERIFY_QR_CODE: envOverride('SLP_API_VERIFY_QR_CODE', '/api/v2/auth/verify-qr-code'),
    USER_CDN_API_USER_REVISION: envOverride('USER_CDN_API_USER_REVISION', '/v1/users/revision/:bucketId'),
    AUTO_LOGIN: envOverride('AUTO_LOGIN', '/api/v2/auth/auto-login'),
    AUTH_REFRESH_TOKEN: envOverride('AUTH_REFRESH_TOKEN', '/api/v2/users/auth-token-refresh'),
    REMINDER_API_SET_REMINDER: envOverride('REMINDER_API_SET_REMINDER', '/v2/:apiKey/set/:type'),
    REMINDER_API_UNSET_REMINDER: envOverride('REMINDER_API_UNSET_REMINDER', '/v2/:apiKey/unset'),
    REMINDER_VOD_API_LIST_REMINDER: envOverride('REMINDER_VOD_API_LIST_REMINDER', '/v3/:apiKey/list'),
    REMINDER_LINIER_API_LIST_REMINDER: envOverride('REMINDER_LINIER_API_LIST_REMINDER', '/v3/:apiKey/list'),
    SLP_API_AMAZON_ACTIVATE: envOverride('ENTITLEMENT_ADDON_PURCHASE', '/api/v2/integrations/amazon-activate'),
    ZENDESK_JWT_TOKEN: envOverride('ZENDESK_JWT_TOKEN', '/api/v2/users/zendesk-jwt-token'),
    ZENDESK_JWT_TOKEN_CLASSIC: envOverride('ZENDESK_JWT_TOKEN_CLASSIC', '/api/v2/users/zendesk-jwt-token-classic'),
    DEVICE_PAIRING: envOverride('DEVICE_PAIRING', '/api/v2/auth/authenticate-qr-code'),
    // BOOKMARK_API: envOverride('BOOKMARK_API', '/v2/:apiKey/profile/:profileName/bookmarks'),
    BOOKMARK_API: envOverride('BOOKMARK_API', '/v3/:apiKey/profile/:profileGuid'),
    BOOKMARK_API_DETAIL: envOverride('BOOKMARK_API_DETAIL', '/v2/:apiKey/profile/:profileName/bookmarks/detail'),
    GEO_LOCATION_API_GET_MY_LOCATION: envOverride('GEO_LOCATION_API_GET_MY_LOCATION', '/v1/mylocation'),
    POPCORN_API_GET_ALL_PROMOTIONS: envOverride(
        'POPCORN_API_GET_ALL_PROMOTIONS',
        '/v1/promotions?apikey=:apikey&device=:device&country=:country&subscriptionGuids=:subscriptionGuids&tierGuid=:tierGuid&operator=:operator&productKey=:productKey&range=:range&area=:area'
    ),
    POPCORN_API_GET_ALL_REWIND: envOverride('POPCORN_API_GET_ALL_REWIND', '/v1/rewind'),
    DISCOUNT_API_VALIDATE_GIFT_CARD: envOverride(
        'DISCOUNT_API_VALIDATE_GIFT_CARD',
        '/api/v2/discount-validate-voucher'
    ),
    DISCOUNT_API_SUBSCRIBE_BY_GIFT_CARD: envOverride(
        'DISCOUNT_API_SUBSCRIBE_BY_GIFT_CARD',
        '/api/v2/subscribe-by-gift-card'
    ),
    DISCOUNT_API_RESUBSCRIBE_BY_GIFT_CARD: envOverride(
        'DISCOUNT_API_RESUBSCRIBE_GIFT_CARD',
        '/api/v2/users/resubscribe-by-gift-card'
    ),
    DISCOUNT_API_GIFT_CARD_USER_RESUBSCRIBE: envOverride(
        'DISCOUNT_API_GIFT_CARD_USER_RESUBSCRIBE',
        '/api/v2/subscriptions/gift-card-user-resubscribe'
    ),
    DISCOUNT_API_GIFT_CARD_USER_RESUBSCRIBE_VERIFY: envOverride(
        'DISCOUNT_API_GIFT_CARD_USER_RESUBSCRIBE_VERIFY',
        '/api/v2/subscriptions/gift-card-user-resubscribe-verify'
    ),

    CHANNELS_HISTORY: envOverride('CHANNELS_HISTORY', '/v1/:apiKey/profile/:profileName/channels/history'),
    SERIES_HISTORY: envOverride('SERIES_HISTORY', '/v1/:apiKey/profile/:profileName/series/history'),
    PROFILE_WATCH_HISTORY: envOverride(
        'PROFILE_WATCH_HISTORY',
        '/v1/:apiKey/users/:userName/profile/:profileName/viewerShip/history'
    ),
    THINK_ANALYTICS_API_GET_VOD_LIST: envOverride('THINK_ANALYTICS_API_GET_VOD_LIST', '/v1/:apiKey/usecase'),
    GATEWAY_CONFIGURATION: envOverride('GATEWAY_CONFIGURATION', '/v1/config/detail/:appKey'),
    GATEWAY_LANGUAGE: envOverride('GATEWAY_LANGUAGE', '/v1/config/language/:language/?appKey=:appKey'),
    GATEWAY_SCREEN: envOverride('GATEWAY_SCREEN', '/v1/config/:appKey/layout/:layout'),

    THINK_ANALYTICS_API_GET_VODLIST_AND_YOU_WATCHED: envOverride(
        'THINK_ANALYTICS_API_GET_VODLIST_AND_YOU_WATCHED',
        '/v1/:apiKey/usecase'
    ),
    THINK_ANALYTICS_API_GET_RELATED: envOverride('THINK_ANALYTICS_API_GET_RELATED', '/v1/:apiKey/usecase/related'),
    THINK_ANALYTICS_API_GET_RELATED_OTHERS: envOverride(
        'THINK_ANALYTICS_API_GET_RELATED_OTHERS',
        '/v1/:apiKey/usecase/relatedOthers'
    ),
    BOOKMARK_API_WATCH_AGAIN: envOverride('BOOKMARK_API_WATCH_AGAIN', '/v1/:apiKey/profile/:profileName/watched'),
    THINK_ANALYTICS_API_SEARCH_SUGGESTIONS: envOverride(
        'THINK_ANALYTICS_API_SEARCH_SUGGESTIONS',
        '/v1/:apiKey/searchSuggestions'
    ),
    THINK_ANALYTICS_API_SEARCH_PA: envOverride('THINK_ANALYTICS_API_SEARCH_PA', '/v1/:apiKey/searchPa'),
    CONTENT_LIKE_DISLIKE_RATING: envOverride('CONTENT_LIKE_DISLIKE_RATING', '/v1/:apiKey/actions/rating'),
    SLP_COUNTRY_CONFIGS: envOverride('SLP_COUNTRY_CONFIGS', '/api/v2/users/user-country-configurations-v2'),
    RESUBSCRIBE_OTP_SEND: envOverride('RESUBSCRIBE_OTP_SEND', '/api/v2/subscriptions/resubscribe-otp-send'),
    RESUBSCRIBE_OTP_VERIFY: envOverride('RESUBSCRIBE_OTP_VERIFY', '/api/v2/subscriptions/resubscribe-otp-verify'),
    PAYMENT_SWITCH_GENERATE: envOverride('PAYMENT_SWITCH_GENERATE', '/api/v2/users/payment-switch-generate'),
    PAYMENT_SWITCH_VERIFY: envOverride('PAYMENT_SWITCH_VERIFY', '/api/v2/users/payment-switch-verify'),
    RESUBSCRIBE_CREDIT_CARD: envOverride('RESUBSCRIBE_CREDIT_CARD', '/api/v2/subscriptions/resubscribe-credit-card'),
    SLP_BUNDLE_SAVE: envOverride('SLP_BUNDLE_SAVE', '/api/v2/subscriptions/bundle-save'),
    SLP_BUNDLE_SAVE_INFO: envOverride('SLP_BUNDLE_SAVE_INFO', '/api/v2/bundle-and-save-info'),
    SLP_BUNDLE_SAVE_RULES: envOverride('SLP_BUNDLE_SAVE_RULES', '/api/v2/bundle-and-save-rules'),
    ACTIVE_SUB_VOUCHER: envOverride('ACTIVE_SUB_VOUCHER', '/api/v2/discount-redeem-active-voucher'),
    SLP_BOLT_SUBSCRIPTION: envOverride('SLP_BOLT_SUBSCRIPTION', '/api/v2/subscription/bolt-register'),
    SLP_BOLT_SUBSCRIPTION_TWO_STEPS: envOverride(
        'SLP_BOLT_SUBSCRIPTION_TWO_STEPS',
        '/api/v2/subscription/bolt-register-two-steps'
    ),
    RBO_RESUB: envOverride('RBO_RESUB', '/api/v2/users/rbo-resubscribe'),
    RBO_RESUB_VERIFY: envOverride('RBO_RESUB_VERIFY', '/api/v2/users/resubscribeOtpVerify'),

    SLP_BOLT_VERIFICATION_TWO_STEPS: envOverride(
        'SLP_BOLT_VERIFICATION_TWO_STEPS',
        '/api/v2/subscription/bolt-verify-two-steps'
    ),
    SLP_QITAF_GENERATE_OTP: envOverride('SLP_QITAF_GENERATE_OTP', '/api/v2/qitaf/generate-otp'),
    SLP_QITAF_VERIFY_OTP: envOverride('SLP_QITAF_VERIFY_OTP', '/api/v2/qitaf/verify-otp'),
    LEARN_ACTION_SET_PREFERENCES: envOverride('LEARN_ACTION_SET_PREFERENCES', '/v1/:apiKey/actions/preferences'),
    SEARCH_ACTION_CLICK: envOverride('SEARCH_ACTION_CLICK', '/v1/:apiKey/actions/click'),
    LEARN_EVENTS: envOverride('LEARN_EVENTS', '/v1/:apiKey/actions'),
    THINK_ANALYTICS_API_GET_BECAUSE_YOU_WATCH_MULTIPLE: envOverride(
        'THINK_ANALYTICS_API_GET_RELATED_OTHERS',
        '/v1/:apiKey/usecase/byw'
    ),
    SLP_USER_REGISTRATION: envOverride('SLP_USER_REGISTRATION', '/api/v2/subscription/user-registration'),
    SLP_USER_REGISTRATION_GENERATE_PIN: envOverride(
        'SLP_USER_REGISTRATION_GENERATE_PIN',
        '/api/v2/subscription/user-registration-generate-pin'
    ),
    SLP_USER_REGISTRATION_VERIFY_PIN: envOverride(
        'SLP_USER_REGISTRATION_VERIFY_PIN',
        '/api/v2/subscription/user-registration-verify-pin'
    ),
    NOTIFICATIONS_VALIDATE_VOC_TOKEN: envOverride(
        'NOTIFICATIONS_VALIDATE_VOC_TOKEN',
        '/api/v2/notifications/voc/token'
    ),
    SLP_LEGACY_CC_MIGRATE: envOverride('SLP_LEGACY_CC_MIGRATE', '/api/v2/users/legacy-migrate'),
    SLP_LEGACY_DCB_MIGRATE_GENERATE: envOverride(
        'SLP_LEGACY_DCB_MIGRATE_GENERATE',
        '/api/v2/users/legacy-migrate-generate'
    ),
    SLP_LEGACY_DCB_MIGRATE_VERIFY: envOverride('SLP_LEGACY_DCB_MIGRATE_VERIFY', '/api/v2/users/legacy-migrate-verify'),
    USER_CONSENT_API: envOverride('USER_CONSENT_API', '/v1/:apiKey/consents'),
    MPX_ALL_EPISODES: envOverride('MPX_ALL_EPISODES', 'all-vod-episodes-pavail'),
    // GET_PROVIDERS: envOverride('GET_PROVIDERS', '/api/v2/users/legacy-migrate-verify'),
    THINK_ANALYTICS_API_GET_FEELING_LUCKY: envOverride(
        'THINK_ANALYTICS_API_GET_FEELING_LUCKY',
        '/v1/:apiKey/usecase/ifl?profileName=:profileName&userName=:userName&device=:device&country=:country&subGuids=:subGuids&rating=:rating'
    ),

    THINK_ANALYTICS_API_GET_MOOD_MOVIES: envOverride(
        'THINK_ANALYTICS_API_GET_MOOD_MOVIES',
        '/v1/:apiKey/usecase?useCaseId=:useCaseId&profileName=:profileName&userName=:userName&device=:device&country=:country&subGuids=:subGuids&rating=:rating&programType=VOD'
    ),
    BIGSCREEN_CMS_STC_PLAY_GAMES: envOverride('BIGSCREEN_CMS_STC_PLAY_GAMES', '/stc-tv/locale/configs/games.json'),
    GATEWAY_LANGUAGE_EN: envOverride('GATEWAY_LANGUAGE_EN', '/stc-tv/locale/configs/wcp_app_en.json'),
    GATEWAY_LANGUAGE_AR: envOverride('GATEWAY_LANGUAGE_AR', '/stc-tv/locale/configs/wcp_app_ar.json'),
    MPX_BIOGRAPHY: envOverride('MPX_BIOGRAPHY', '/:apikey/gm-st-biography'),
    LOGOUT_API: envOverride('LOGOUT_API', '/api/v2/auth/logout'),
    PPV_PURCHASE_GENERATE_PIN: envOverride(
        'PPV_PURCHASE_GENERATE_PIN',
        '/api/v2/subscriptions/ppv-purchase-generate-pin'
    ),
    PPV_PURCHASE_VERIFY_PIN: envOverride('PPV_PURCHASE_VERIFY_PIN', '/api/v2/subscriptions/ppv-purchase-verify-pin'),
    PPV_PURCHASE: envOverride('PPV_PURCHASE', '/api/v2/subscriptions/ppv-purchase'),
    FAVORITES_CHANNELS_ADD: envOverride(
        'FAVORITES_CHANNELS_ADD',
        '/profiles/v2/:apiKey/profile/:profileName/favorites/channels'
    ),
    FAVORITES_CHANNELS_GET: envOverride(
        'FAVORITES_CHANNELS_GET',
        '/profiles/v2/:apiKey/profile/:profileName/favorites/channels'
    ),
    FAVORITES_CHANNELS_DELETE: envOverride(
        'FAVORITES_CHANNELS_DELETE',
        '/profiles/v2/:apiKey/profile/:profileName/favorites/channels'
    ),
    PPV_GET_COUNTRY_CONFIG: envOverride('PPV_GET_COUNTRY_CONFIG', '/v1/ppv/country/configs'),
    PPV_GET_EVENT_CONFIG: envOverride('PPV_GET_EVENT_CONFIG', '/v1/ppv/event/configs'),
    CAMPAIGN_GENERATE: envOverride('CAMPAIGN_GENERATE', '/api/v2/campaign/generate'),
    CAMPAIGN_VERIFY: envOverride('CAMPAIGN_VERIFY', '/api/v2/campaign/verify'),
    CHECK_USER: envOverride('CHECK_USER', '/api/v2/subscription/check-user'),
    // CAMPAIGN_GENERATE: envOverride('CAMPAIGN_GENERATE', '/api-v2/campaign-generate'),
    // CAMPAIGN_VERIFY: envOverride('CAMPAIGN_VERIFY', '/api-v2/campaign-verify'),
    // CHECK_USER: envOverride('CHECK_USER', '/api-v2/subscription/check-user'),
    SUBSCRIPTION_VALIDATE_ACTIVATION_LINK: envOverride(
        'SUBSCRIPTION_VALIDATE_ACTIVATION_LINK',
        '/api/v2/partner/partner-validate-activation-link'
    ),
    SUBSCRIPTION_DISNEY_GENERATE_OTP: envOverride(
        'SUBSCRIPTION_DISNEY_GENERATE_OTP',
        '/api/v2/partner/partner-generate-otp'
    ),
    SUBSCRIPTION_DISNEY_VALIDATE_OTP: envOverride(
        'SUBSCRIPTION_DISNEY_VALIDATE_OTP',
        '/api/v2/partner/partner-validate-otp'
    ),
    SUBSCRIPTION_DISNEY_REQUEST_ACTIVATION_LINK: envOverride(
        'SUBSCRIPTION_DISNEY_REQUEST_ACTIVATION_LINK',
        '/api/v2/partner/partner-activation-link-request'
    ),
    FORGET_PIN_RESEND: envOverride('FORGET_PIN_RESEND', '/api/v2/auth/forgot-resend-pin'),
    VERIFY_EMAIL: envOverride('VERIFY_EMAIL', '/api/v2/auth/verify-email'),
};
